import React, { useState, useEffect } from 'react';
import { Grid, TextField, Typography, MenuItem, Divider, FormControlLabel, Checkbox } from '@material-ui/core';
import { PARENTESCOS_BIENESTAR } from '../../../helper';
import { obtenerValoresFiltros } from '../../../../../global/js/funciones';
import { FORM_DICTIONARY } from '../schemas/formFields';


/* =============================================
    PASO 2: Salud Mental y Factores de Riesgo
   ============================================= */
function PasoSaludYRiesgo({ data, onChange }) {
    const [parentescos, setParentescos] = useState([]);
    const safeValue = (field) => (data?.[field]?.valor || '');
    const safeError = (field) => (data?.[field]?.error || '');
    const safeBool = (field) => !!data?.[field]?.valor;
    const campos_generales = FORM_DICTIONARY.fichas.general;

    // Cargar opciones de parentesco
    useEffect(() => {
        const cargarParentescos = async () => {
            try {
                const data = await obtenerValoresFiltros([{ llave: 'generica', valor: PARENTESCOS_BIENESTAR },{ llave: 'estado', valor: 1 }]);
                const opcionesParentesco = (Array.isArray(data) ? data : []).map(item => ({
                    value: item.id || item.codigo || item.valor,
                    label: item.nombre || item.valor || item.label || ""
                }));
                setParentescos(opcionesParentesco);
            } catch (error) {
                console.error('Error  cargando parentescos:', error);
            }
        };
        cargarParentescos();
    }, []);

    return (
        <Grid container spacing={2}>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label={campos_generales.nombre_eps.label}
                    name={campos_generales.nombre_eps.name}
                    value={safeValue(campos_generales.nombre_eps.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.nombre_eps.name)}
                    helperText={safeError(campos_generales.nombre_eps.name)}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    select
                    label={campos_generales.sisben.label}
                    name={campos_generales.sisben.name}
                    value={safeValue(campos_generales.sisben.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.sisben.name)}
                    helperText={safeError(campos_generales.sisben.name)}
                >
                    <MenuItem value="SI">Sí</MenuItem>
                    <MenuItem value="NO">No</MenuItem>
                </TextField>
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label={campos_generales.no_vinculado.label}
                    name={campos_generales.no_vinculado.name}
                    value={safeValue(campos_generales.no_vinculado.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.no_vinculado.name)}
                    helperText={safeError(campos_generales.no_vinculado.name)}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label={campos_generales.grupo_priorizado.label}
                    name={campos_generales.grupo_priorizado.name}
                    value={safeValue(campos_generales.grupo_priorizado.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.grupo_priorizado.name)}
                    helperText={safeError(campos_generales.grupo_priorizado.name)}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    label={campos_generales.se_auto_reconoce_grupo_priorizado.label}
                    name={campos_generales.se_auto_reconoce_grupo_priorizado.name}
                    value={safeValue(campos_generales.se_auto_reconoce_grupo_priorizado.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.se_auto_reconoce_grupo_priorizado.name)}
                    helperText={safeError(campos_generales.se_auto_reconoce_grupo_priorizado.name)}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    select
                    label={campos_generales.certificado_grupo_priorizado.label}
                    name={campos_generales.certificado_grupo_priorizado.name}
                    value={safeValue(campos_generales.certificado_grupo_priorizado.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.certificado_grupo_priorizado.name)}
                    helperText={safeError(campos_generales.certificado_grupo_priorizado.name)}
                >
                    <MenuItem value="SI">Sí</MenuItem>
                    <MenuItem value="NO">No</MenuItem>
                </TextField>
            </Grid>

            
            {[
                { label: campos_generales.ideacion_suicida.label, name: campos_generales.ideacion_suicida.name, required: true },
                { label: campos_generales.intento_suicida.label, name: campos_generales.intento_suicida.name, required: true },
                { label: campos_generales.conducta_suicida.label, name: campos_generales.conducta_suicida.name, required: true },
                { label: campos_generales.deseo_muerte.label, name: campos_generales.deseo_muerte.name, required: true },
                { label: campos_generales.deseo_danarse.label, name: campos_generales.deseo_danarse.name, required: true },
                { label: campos_generales.plan_suicida.label, name: campos_generales.plan_suicida.name, required: true },
                { label: campos_generales.trataste_suicidarte.label, name: campos_generales.trataste_suicidarte.name, required: true }
            ].map((preg) => (
                <Grid item xs={12} md={4} key={preg.name}>
                    <TextField 
                        fullWidth 
                        select 
                        label={preg.label} 
                        name={preg.name} 
                        value={safeValue(preg.name)} 
                        onChange={onChange}
                        error={!!safeError(preg.name)}
                        helperText={safeError(preg.name)}
                        required={preg.required}
                    >
                        <MenuItem value="SI">Sí</MenuItem>
                        <MenuItem value="NO">No</MenuItem>
                    </TextField>
                </Grid>
            ))}


            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    select
                    label={campos_generales.toma_medicamentos.label}
                    name={campos_generales.toma_medicamentos.name}
                    value={safeValue(campos_generales.toma_medicamentos.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.toma_medicamentos.name)}
                    helperText={safeError(campos_generales.toma_medicamentos.name)}
                >
                    <MenuItem value="SI">Sí</MenuItem>
                    <MenuItem value="NO">No</MenuItem>
                </TextField>
            </Grid>

            {safeValue(campos_generales.toma_medicamentos.name) === 'SI' && (
            <Grid item xs={12} md={4}>
                <TextField
                fullWidth
                label={campos_generales.nombre_medicamentos.label}
                name={campos_generales.nombre_medicamentos.name}
                value={safeValue(campos_generales.nombre_medicamentos.name)}
                onChange={onChange}
                required
                error={!!safeError(campos_generales.nombre_medicamentos.name)}
                helperText={safeError(campos_generales.nombre_medicamentos.name)}
                />
            </Grid>
            )}

            <Grid item xs={12} md={4}>
                <TextField
                    fullWidth
                    select
                    label={campos_generales.diagnostico_previo.label}
                    name={campos_generales.diagnostico_previo.name}
                    value={safeValue(campos_generales.diagnostico_previo.name)}
                    onChange={onChange}
                    required
                    error={!!safeError(campos_generales.diagnostico_previo.name)}
                    helperText={safeError(campos_generales.diagnostico_previo.name)}
                >
                    <MenuItem value="SI">Sí</MenuItem>
                    <MenuItem value="NO">No</MenuItem>
                </TextField>
            </Grid>

            {safeValue(campos_generales.diagnostico_previo.name) === 'SI' && (
            <Grid item xs={12} md={4}>
                <TextField
                fullWidth
                label={campos_generales.diagnostico.label}
                name={campos_generales.diagnostico.name}
                value={safeValue(campos_generales.diagnostico.name)}
                onChange={onChange}
                required
                error={!!safeError(campos_generales.diagnostico.name)}
                helperText={safeError(campos_generales.diagnostico.name)}
                />
            </Grid>
            )}

            <Grid item xs={12} md={12}></Grid>

        </Grid>
    );
}

/* =============================================
    PASO 3: Descripción de la Crisis
   ============================================= */
function PasoDescripcionCrisis({ data, onChange }) {
    const safeValue = (field) => (data?.[field]?.valor || '');
    const safeError = (field) => data?.[field]?.error || '';
    const campos_crisis = FORM_DICTIONARY.fichas.crisis;
    const CAMPOS_DESCRIPCION = [
        { label: campos_crisis.descripcion_crisis.label, name: campos_crisis.descripcion_crisis.name, required: true },
        { label: campos_crisis.motivo_crisis.label, name: campos_crisis.motivo_crisis.name, required: true },
        { label: campos_crisis.resumen_procedimiento.label, name: campos_crisis.resumen_procedimiento.name, required: true },
        { label: campos_crisis.recomendaciones.label, name: campos_crisis.recomendaciones.name, required: true },
        { label: campos_crisis.seguimiento_1.label, name: campos_crisis.seguimiento_1.name, required: true },
        { label: campos_crisis.seguimiento_2.label, name: campos_crisis.seguimiento_2.name, required: true },
        { label: campos_crisis.seguimiento_3.label, name: campos_crisis.seguimiento_3.name, required: true },
        { label: campos_crisis.seguimiento_4.label, name: campos_crisis.seguimiento_4.name, required: true },
        { label: campos_crisis.seguimiento_5.label, name: campos_crisis.seguimiento_5.name },
        { label: campos_crisis.seguimiento_6.label, name: campos_crisis.seguimiento_6.name },
        ];

    return (

        <Grid container spacing={2}>

            {CAMPOS_DESCRIPCION.map(campo => (
                <Grid item xs={12} md={6} key={campo.name}>
                <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label={campo.label}
                    name={campo.name}
                    value={safeValue(campo.name)}
                    onChange={onChange}
                    required={campo.required}
                    error={!!safeError(campo.name)}
                    helperText={safeError(campo.name)}
                />
                </Grid>
            ))}

            <Grid item xs={12}>
                <TextField
                fullWidth
                select
                label={campos_crisis.nivel_riesgo.label}
                name={campos_crisis.nivel_riesgo.name}
                value={safeValue(campos_crisis.nivel_riesgo.name)}
                onChange={onChange}
                required
                error={!!safeError(campos_crisis.nivel_riesgo.name)}
                helperText={safeError(campos_crisis.nivel_riesgo.name)}
                >
                <MenuItem value="BAJO">🟢 BAJO</MenuItem>
                <MenuItem value="MEDIO">🟡 MEDIO</MenuItem>
                <MenuItem value="ALTO">🔴 ALTO</MenuItem>
                </TextField>
            </Grid>

        </Grid>

    );
}

/* =============================================
    EXPORTACIÓN DE PASOS
   ============================================= */
export const StepsAtencionCrisis = [
    {
        label: 'Riesgos y Salud',
        render: (props) => <PasoSaludYRiesgo {...props} />
    },
    {
        label: 'Descripción de Crisis',
        render: (props) => <PasoDescripcionCrisis {...props} />
    }
];